import { accessCodes } from '@gat-ship/types'

export const LOADING_IDS = {
  extract: 'smart-paste-extract',
  assets: 'smart-paste-assets'
} as const

export const AI_PERMISSIONS = {
  manageAssets: accessCodes.system.aiPromptLibrary.manage,
  overrideModel: accessCodes.system.aiPromptLibrary.overrideModelForRequest
} as const
